<app-modal #modal [isLoading]="isRegistering" (dismiss)="onDismiss()">
    <ng-container modal-header>
        {{ 'admin.users.emdRegisterModal.title' | translate }}
    </ng-container>

    <ng-container modal-body>
        <div class="emd-register-modal">
            <div class="search-field">
                <label class="search-field__label">{{ 'admin.users.emdRegisterModal.search.label' | translate }}</label>
                <app-search-autocomplete [(ngModel)]="selectedEmployee"
                                         [items]="employees"
                                         displayField="displayName"
                                         [placeholder]="'admin.users.emdRegisterModal.search.placeholder' | translate"
                                         [minSearchLength]="4"
                                         [debounceMs]="500"
                                         (searchChange)="onEmployeeSearch($event)"
                                         (selectItem)="onEmployeeSelected($event)">
                </app-search-autocomplete>
            </div>

            <div class="employee-preview" *ngIf="hasSelectedEmployee">
                <div class="employee-preview__line">
                    <strong>{{ 'admin.users.emdRegisterModal.preview.ntAccount' | translate }}:</strong>
                    <span>{{ selectedEmployee.ntAccount || ('generic.notAvailable' | translate) }}</span>
                </div>
                <div class="employee-preview__line">
                    <strong>{{ 'admin.users.emdRegisterModal.preview.email' | translate }}:</strong>
                    <span>{{ selectedEmployee.email || ('generic.notAvailable' | translate) }}</span>
                </div>
                <div class="employee-preview__line">
                    <strong>{{ 'admin.users.emdRegisterModal.preview.badge' | translate }}:</strong>
                    <span>{{ selectedEmployee.badgeId || selectedEmployee.badgeRfid || ('generic.notAvailable' | translate) }}</span>
                </div>
            </div>

            <app-dropdown [(ngModel)]="selectedUserBusinessType"
                          [items]="userBusinessTypes"
                          valueField="value"
                          displayField="name"
                          labelAlign="top"
                          label="{{ 'admin.users.emdRegisterModal.businessType.label' | translate }}"
                          emptyText="{{ 'admin.users.emdRegisterModal.businessType.placeholder' | translate }}">
            </app-dropdown>
        </div>
    </ng-container>

    <ng-container modal-footer>
        <div class="modal-actions">
            <app-button type="simple" (clicked)="close()">
                {{ 'generic.buttons.close' | translate }}
            </app-button>

            <app-button type="primary"
                        [disabled]="!canRegister || isRegistering"
                        (clicked)="onRegister()">
                {{ 'admin.users.emdRegisterModal.register' | translate }}
            </app-button>
        </div>
    </ng-container>
</app-modal>
